/* eslint-disable */
const en = {
    nav_experiences: "Experiences",
    nav_destinations: "Destinations",
    nav_attractions: "Attractions",
    nav_reviews: "Reviews",
    language: "Language",
    sign_in: "Sign In",
    hero_title: "Discover Sitges & Beyond",
    hero_search_placeholder: "Sitges, Barcelona, Tarragona...",
    hero_where: "Where to?",
    hero_when: "When",
    hero_select_dates: "Select dates",
    hero_search: "Search",
    benefits_title: "Why book with SitgesVibes?",
    benefit_1_title: "Handpicked coastal experiences",
    benefit_1_desc: "Every experience is curated by locals who know the Mediterranean coast inside out.",
    benefit_2_title: "Free cancellation",
    benefit_2_desc: "Plans change. Cancel most experiences up to 24 hours ahead for a full refund.",
    benefit_3_title: "24/7 support",
    benefit_3_desc: "No matter the time zone, our team is here to help you every step of the way.",
    benefit_4_title: "Best price guarantee",
    benefit_4_desc: "Found it cheaper elsewhere? We'll match the price so you always get the best deal.",
    categories_title: "Explore by Category",
    locations_title: "Explore by Location",
    destinations_title: "Top Destinations",
    tours_label: "Tours",
    experiences_title: "Top Experiences",
    from_price: "from",
    free_price: "Free",
    limited_event: "Limited Event",
    events_title: "Events",
    cat_events: "Events",
    view_all_events: "View All Events",
    per_person: "per person",
    see_all: "See all",
    likely_to_sell_out: "Likely to Sell Out",
    no_results: "No experiences found. Try a different search.",
    clear_filters: "Clear filters",
    attractions_title: "Top Attractions",
    tours_and_activities: "Tours and Activities",
    reviews_title: "What travelers say",
    reviews_subtitle: "Based on real experiences from our community",
    excellent: "Excellent",
    based_on_reviews: "Based on {count} reviews",
    flexible_title: "Keep things flexible",
    flexible_desc: "Free cancellation on most experiences. Book now, pay later â no extra cost.",
    footer_about_title: "About SitgesVibes",
    footer_about_desc: "Your gateway to the best experiences in Sitges and along the Catalan Mediterranean coast.",
    footer_popular_cities: "Popular Cities",
    footer_popular_attractions: "Popular Attractions",
    footer_support: "Support",
    footer_help: "Help Center",
    footer_contact: "Contact Us",
    footer_terms: "Terms of Service",
    footer_privacy: "Privacy Policy",
    footer_rights: "All rights reserved.",
    search_results_title: "Search Results",
    showing_results: "Showing {count} results",
    view_on: "View on",
    back: "Back",
    featured: "Featured",
    book_now: "Availability",
    more_information: "Details",
    search: "Search",
    search_experiences: "Find places and things to do",
    wishlist: "Wishlist",
    view_all_experiences: "View All Experiences",
    view_all_places: "View All Places",
    view_all_activities: "View All Activities",
    wishlist_empty: "Your wishlist is empty",
    hero_subtitle: "Sitges & Beyond",
    no_experiences_found: "No experiences found matching your filters.",
    clear_all_filters: "Clear all filters",
    empty_no_match_title: "No matches found",
    empty_no_results_title: "Nothing matches yet",
    empty_no_match_for: "We couldn't find anything for",
    empty_try_broader: "Try removing a filter or broadening your search.",
    empty_remove_filter_hint: "Try removing one of your filters to see more options.",
    empty_browse_all: "Browse all experiences",
    loc_sitges: "Sitges",
    loc_barcelona: "Barcelona",
    loc_tarragona: "Tarragona",
    loc_day_trips: "Day Trips",
    footer_external_links_title: "External Links & Affiliate Disclosure",
    footer_external_links_desc: "Some links on this website lead to external booking platforms. We may earn a commission if you book through these links, at no extra cost to you.",
    footer_contact_title: "Contact",
    legal_privacy_policy: "Privacy Policy",
    legal_cookie_policy: "Cookie Policy",
    legal_legal_notice: "Legal Notice",
    sitges_guide_static_title: "Sitges Guide",
    sitges_guide_coming_soon: "Content coming soon.",
    loading: "Loading…",
    sitges_guide_title: "Sitges Guide",
    continue_reading: "Continue reading",
    things_to_do: "Things to do",
    places_to_visit: "Places to visit",
    location: "Location",
    nearby: "Nearby",
    cat_tours_sightseeing: "Tours & Sightseeing",
    cat_food_wine: "Food & Wine",
    cat_water_activities: "Water Activities",
    cat_beaches: "Hotels",
    cat_culture_arts: "Culture & Arts",
    cat_nightlife: "Nightlife",
    cat_romantic: "Romantic",
    cat_romantic_experiences: "Romantic",
    cat_transfers: "Travel Essentials",
    live_tour_guide: "Tour Guide:",
    audio_available_in: "Audio Available In:",
    more_details_at: "More details at:",
    currency_eur: "Euro",
    currency_usd: "US Dollar",
    currency_gbp: "British Pound",
    currency_chf: "Swiss Franc",
    currency_cad: "Canadian Dollar",
    currency_aud: "Australian Dollar",
    currency_jpy: "Japanese Yen",
    currency_cny: "Chinese Yuan",
    destination_sitges: "Sitges",
    destination_barcelona: "Barcelona",
    destination_nearby: "Nearby",
    destination_montserrat: "Montserrat",
    destination_penedes: "Penedès",
    destination_tarragona: "Tarragona",
    destination_day_trips: "Day Trips",
    consent_title: "We value your privacy",
    consent_body: "We use cookies and similar technologies to analyse traffic and improve your experience. You can accept or reject non-essential analytics. See our",
    consent_accept: "Accept all",
    consent_reject: "Reject",
    consent_aria: "Cookie consent",
    reset_cookie_preferences: "Reset cookie preferences",
    selected_badge: "Selected",
  };
export default en;
